<template>
  <a-form
    id="msgLoginForm"
    :form="form"
    class="login-form"
    @submit="loginSubmit"
  >
    <a-form-item>
      <a-input
        v-decorator="[
          'phone',
          {
            rules: [
              { required: true, message: '请输入手机号' },
              {
                pattern: /^[1][3,4,5,6,7,8,9][0-9]{9}$|^[5|6|8|9][0-9]{7}$/,
                message: '请输入正确的手机号',
              },
            ],
          },
        ]"
        placeholder="请输入手机号"
      >
        <a-icon
          slot="prefix"
          type="mobile"
          style="color: rgba(0, 0, 0, 0.25)"
        />
      </a-input>
    </a-form-item>
    <a-form-item>
      <a-input-search
        v-decorator="[
          'code',
          { rules: [{ required: true, message: '请输入手机验证码' }] },
        ]"
        type="text"
        placeholder="请输入手机验证码"
        :enter-button="txt"
        @search="getMsgCode"
      >
      </a-input-search>
    </a-form-item>
    <a-button type="primary" html-type="submit" class="login-form-button">
      登录
    </a-button>
  </a-form>
</template>

<script>
import { createNamespacedHelpers } from "vuex";
const { mapActions } = createNamespacedHelpers("account");
// mapState
export default {
  beforeCreate() {
    // this.form = this.$form.createForm(this);
  },
  data() {
    return {
      formLayout: "horizontal",
      form: this.$form.createForm(this),
      txt: "获取验证码",
      time: 60,
      interval: null,
      disabled: false,
    };
  },
  methods: {
    ...mapActions(["regLogCodeAct", "getMsgCodeAct", "getStudentInfo"]),
    getMsgCode() {
      if (this.disabled) return;
      this.form.validateFields(["phone"], (errors, values) => {
        if (errors) return;
        this.minusTime();
        this.getMsgCodeAct(values.phone);
      });
    },
    minusTime() {
      this.txt = `重新发送(${this.time}s)`;
      this.disabled = true;
      let interval = setInterval(() => {
        this.time -= 1;
        this.txt = `重新发送(${this.time}s)`;
        if (this.time <= 0) {
          clearInterval(interval);
          this.txt = `获取验证码`;
          this.disabled = false;
          this.time = 60;
        }
      }, 1000);
    },
    loginSubmit(e) {
      e.preventDefault();
      const isDuringDate = sessionStorage.getItem("isDuringDate");
      if (!JSON.parse(isDuringDate)) {
        this.$warning({
          content: "系统暂未开放",
          okText: "知道了",
          okType: "primary",
          maskClosable: true,
        });
        return;
      }
      this.form.validateFields((err, values) => {
        if (!err) {
          this.regLogCodeAct(values).then((res) => {
            //console.log("msg-res", res);
            this.loginStatusJudge(res.data);
          });
        }
      });
    },
    loginStatusJudge(data) {
      if (data.status == 2000) {
        localStorage.setItem("apply_studentInfo", JSON.stringify(data));
        if (
          data.data.examEnrollInfoDto.currentStatus == 13 ||
          data.data.examEnrollInfoDto.currentStatus == 15
        ) {
          this.$router.replace(
            `/admission?id=${data.data.examEnrollInfoDto.enrollInfoId}`
          );
        } else {
          this.$warning({
            content: "没有您的准考证信息",
            okText: "知道了",
            okType: "primary",
            maskClosable: true,
          });
        }
      } else {
        this.$warning({
          content: data.message,
          okText: "知道了",
          okType: "primary",
          maskClosable: true,
        });
      }
      // if (data.status == 2000) {
      //   let userInfo = data.data.userInfo;

      //   let params = {
      //     examCode: userInfo.examCode ? userInfo.examCode : baseConf.examCode,
      //     userCode: userInfo.userCode,
      //   };

      //   this.getStudentInfo(params).then((res) => {
      //     let { data, status } = res.data;
      //     localStorage.setItem("apply_studentInfo", JSON.stringify(data));
      //     if (status == "2000") {
      //       if (data.currentStatus == 13 || data.currentStatus == 15) {
      //         this.$router.replace(`/admission?id=${data.enrollInfoId}`);
      //       } else {
      //         this.$warning({
      //           content: "没有您的准考证信息",
      //           okText: "知道了",
      //           okType: "primary",
      //           maskClosable: true,
      //         });
      //       }
      //     } else {
      //       this.$warning({
      //         content: data.message,
      //         okText: "知道了",
      //         okType: "primary",
      //         maskClosable: true,
      //       });
      //     }
      //   });
      // } else {
      //   this.$warning({
      //     content: data.message,
      //     okText: "知道了",
      //     okType: "primary",
      //     maskClosable: true,
      //   });
      // }
    },
  },
};
</script>
<style>
#msgLoginForm .login-form {
  max-width: 300px;
}
#msgLoginForm .login-form-button {
  width: 100%;
}
</style>
